<script lang="ts" context="module">
    import { nextLessonInfo } from "@utils/practice/next-lesson"

    const celebrationPage = writable(true)
    const celebrate = writable<NotificationDataType | null>(null)
    import { confetti } from "@neoconfetti/svelte"
    export function celebrateWorkbook(notfData : NotificationDataType) {
        celebrate.set(notfData)
        celebrationPage.set(true)
    }

    export function uncelebrateWorkbook() {
        celebrate.set(null)
    }
</script>

<script lang="ts">
    import Button from "@components/button/Button.svelte"
    import Logo from "@components/material/Logo.svelte"
    import Popup from "@components/popup/Popup.svelte"
    import PopupExit from "@components/popup/PopupExit.svelte"
    import { donationLink } from "@utils/links"
    import { get, writable } from "svelte/store"
    import { fade } from "svelte/transition"
    import type { NotificationDataType } from "@utils/practice/notifications-data"

</script>

{#if $celebrate}
    <div
        transition:fade
        class="fixed w-full left-0 top-0 h-full z-10 flex items-center justify-center bg-red-100 pointer-events-none"
    >
        <div
            class="opacity-30"
            use:confetti={{ force: 0.9, duration: 15000, particleCount: 75 }}
        ></div>
    </div>
    <div
        transition:fade
        class="fixed w-full left-0 top-0 h-full z-11 flex items-center justify-center pointer-events-none"
    >
        <div use:confetti={{ force: 0.9, particleCount: 75 }}></div>
    </div>

    <Popup
        naked
        on:clickoutside={uncelebrateWorkbook}
        class="overflow-visible backdrop-blur-none bg-white "
    >
        <div class="h-full w-full flex flex-col items-center justify-between">
            <div class="w-full">
                <PopupExit float on:exit={uncelebrateWorkbook} />
            </div>

            <div class="flex items-center flex-col max-w-lg text-center">
                {#if $celebrationPage}
                    <span class="text-2xl italic">Congratulations!</span>
                    <span class="italic">You've completed the workbook!</span>
                    <Logo spinning class="w-64 z-15 m-6" />
                    <span class="italic mb-4">
                        We rely on donations to fuel our work and keep it free so everyone around
                        the world can experience the beauty that A Course in Miracles has to offer.
                        Would you like to help us on our mission?
                    </span>
                    <Button go={donationLink} large target="_blank" icon={"donate"} color="white">
                        Donate
                    </Button>

                    <Button go={() => ($celebrationPage = false)} target="_blank" naked
                        >Continue</Button
                    >
                {:else}
                <span class="text-2xl italic mb-4">What would you like to do?</span>
                    <Button go={async () =>{ await $celebrate.resetReadingAndMoveToLesson(); uncelebrateWorkbook()}} large target="_blank" icon={"donate"} color="white">
                        Restart from Lesson 1
                    </Button>
                    <Button go={uncelebrateWorkbook} target="_blank" naked>Close</Button>
                {/if}
            </div>
            <div></div>
        </div>
    </Popup>
{/if}
